import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
	output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ILabel } from '@app/pages/settings/interfaces/labels.interfaces';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
	selector: 'label-badge',
	imports: [
		CommonModule,
		MatDialogModule,
		MatIconModule,
		MatRippleModule,
		MatTooltipModule,
	],
	templateUrl: './label-badge.component.html',
	styleUrls: ['./label-badge.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabelBadgeComponent {
	label = input<ILabel>();
	limitWidth = input<boolean>(true);
	showCloseButton = input<boolean>(true);
	closeIconClicked = output<ILabel>();
	showTooltip = computed(() => this.label()?.name.length >= 20);
}
